
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openWhatsApp = () => {
    const message = encodeURIComponent('Olá! Vi o site da DataPrec e gostaria de solicitar uma demonstração dos serviços de inteligência de dados e automação. Podem me ajudar?');
    window.open(`https://wa.me/5531981041870?text=${message}`, '_blank');
  };

  return (
    <>
      <section 
        id="inicio" 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(15, 23, 42, 0.85) 0%, rgba(30, 58, 138, 0.75) 50%, rgba(37, 99, 235, 0.65) 100%), url('https://readdy.ai/api/search-image?query=Futuristic%20data%20center%20with%20holographic%20displays%20showing%20financial%20charts%20and%20legal%20documents%2C%20modern%20glass%20architecture%20with%20blue%20neon%20lighting%2C%20sophisticated%20technology%20environment%20with%20floating%20data%20visualizations%2C%20clean%20minimalist%20design%20with%20geometric%20patterns%2C%20professional%20atmosphere%20with%20depth%20and%20perspective&width=1920&height=1080&seq=hero-dataprec-futuristic&orientation=landscape')`
        }}
      >
        {/* Elementos decorativos modernos */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          {/* Grid pattern sutil */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.1) 1px, transparent 1px),
                               linear-gradient(90deg, rgba(59, 130, 246, 0.1) 1px, transparent 1px)`,
              backgroundSize: '50px 50px'
            }}></div>
          </div>

          {/* Elementos flutuantes modernos */}
          <div className="absolute top-20 left-10 w-3 h-20 bg-gradient-to-b from-blue-400 to-transparent animate-pulse"></div>
          <div className="absolute top-40 right-20 w-20 h-3 bg-gradient-to-r from-cyan-400 to-transparent animate-pulse delay-1000"></div>
          <div className="absolute bottom-32 left-20 w-3 h-16 bg-gradient-to-b from-indigo-400 to-transparent animate-pulse delay-2000"></div>
          <div className="absolute bottom-20 right-32 w-16 h-3 bg-gradient-to-r from-blue-400 to-transparent animate-pulse delay-3000"></div>

          {/* Círculos decorativos */}
          <div className="absolute top-32 left-1/4 w-2 h-2 bg-blue-400 rounded-full animate-ping"></div>
          <div className="absolute top-60 right-1/3 w-1.5 h-1.5 bg-cyan-400 rounded-full animate-ping delay-1000"></div>
          <div className="absolute bottom-40 left-1/3 w-2.5 h-2.5 bg-indigo-400 rounded-full animate-ping delay-2000"></div>

          {/* Formas geométricas */}
          <div className="absolute top-1/4 right-1/4 transform rotate-45">
            <div className="w-8 h-8 border-2 border-blue-400/30 animate-spin" style={{animationDuration: '8s'}}></div>
          </div>
          <div className="absolute bottom-1/3 left-1/4 transform rotate-12">
            <div className="w-6 h-6 border-2 border-cyan-400/30 animate-spin" style={{animationDuration: '12s'}}></div>
          </div>
        </div>

        <div className="w-full max-w-7xl mx-auto px-6 py-20 relative z-10">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Conteúdo principal - lado esquerdo */}
            <div className="text-white space-y-8">
              <div className="space-y-6">
                <div className="inline-flex items-center gap-2 bg-blue-500/20 backdrop-blur-sm border border-blue-400/30 text-blue-300 px-4 py-2 rounded-full text-sm font-medium">
                  <i className="ri-database-2-line"></i>
                  Inteligência de Dados
                </div>
                
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                  Inteligência de Dados e Automação para
                  <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-cyan-300 leading-tight">
                    Decisões Estratégicas
                  </span>
                </h1>
                
                <p className="text-lg md:text-xl leading-relaxed text-gray-200 max-w-2xl">
                  Transformamos informações em resultados com soluções inteligentes em coleta, análise e automação de dados para escritórios, empresas e investidores.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 mt-12">
                <button 
                  onClick={scrollToContact}
                  className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-8 py-4 rounded-xl text-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-play-circle-line mr-2"></i>
                  Solicitar Demonstração
                </button>
                <button 
                  onClick={openWhatsApp}
                  className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-xl text-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl flex items-center gap-2 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  WhatsApp
                </button>
              </div>

              {/* Valores da empresa */}
              <div className="pt-8 space-y-4">
                <h3 className="text-xl font-semibold text-blue-200">Nossos Valores</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="flex items-center gap-3 text-gray-200">
                    <div className="w-8 h-8 bg-blue-500/20 rounded-lg flex items-center justify-center">
                      <i className="ri-shield-check-line text-blue-300"></i>
                    </div>
                    <span>Transparência</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-200">
                    <div className="w-8 h-8 bg-cyan-500/20 rounded-lg flex items-center justify-center">
                      <i className="ri-lightbulb-line text-cyan-300"></i>
                    </div>
                    <span>Inovação</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-200">
                    <div className="w-8 h-8 bg-indigo-500/20 rounded-lg flex items-center justify-center">
                      <i className="ri-star-line text-indigo-300"></i>
                    </div>
                    <span>Excelência</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-200">
                    <div className="w-8 h-8 bg-purple-500/20 rounded-lg flex items-center justify-center">
                      <i className="ri-team-line text-purple-300"></i>
                    </div>
                    <span>Parceria</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Área visual - lado direito */}
            <div className="relative lg:block hidden">
              <div className="relative">
                {/* Card principal */}
                <div className="bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl p-8 shadow-2xl">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center">
                      <i className="ri-building-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-white">Nossos Serviços</h3>
                      <p className="text-blue-200 text-sm">Soluções Especializadas</p>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="flex items-center gap-3 text-gray-200">
                      <i className="ri-checkbox-circle-line text-green-400"></i>
                      <span>Raspagem de dados de precatórios e RPV</span>
                    </div>
                    <div className="flex items-center gap-3 text-gray-200">
                      <i className="ri-checkbox-circle-line text-green-400"></i>
                      <span>Automação de processos empresariais</span>
                    </div>
                    <div className="flex items-center gap-3 text-gray-200">
                      <i className="ri-checkbox-circle-line text-green-400"></i>
                      <span>Análise inteligente de dados jurídicos</span>
                    </div>
                    <div className="flex items-center gap-3 text-gray-200">
                      <i className="ri-checkbox-circle-line text-green-400"></i>
                      <span>Relatórios estratégicos personalizados</span>
                    </div>
                  </div>
                </div>

                {/* Card flutuante com tempo de resposta - reposicionado */}
                <div className="absolute -top-4 -right-4 bg-gradient-to-r from-pink-500 to-purple-500 rounded-xl p-4 shadow-xl">
                  <div className="text-white text-center">
                    <div className="text-lg font-bold">15min</div>
                    <div className="text-xs opacity-90">Tempo de Resposta</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Floating Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={openWhatsApp}
          className="bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer flex items-center justify-center animate-pulse"
          title="Fale conosco no WhatsApp"
        >
          <i className="ri-whatsapp-line text-3xl"></i>
        </button>
      </div>
    </>
  );
}
